import {observable, action} from 'mobx';


class datasList {
    @observable mydatas = {
        homejs: false,
        ourpartnerTitle: ''

    }

    @action homeType(type) {
        this.mydatas.homejs = type
    }

    @action ourPartnerStore(title) {
        this.mydatas.ourpartnerTitle = title
    }


}


const datas = new datasList;
export default datas



// WEBPACK FOOTER //
// ./src/store.js